import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\notifyError.ts.esbuild-plugin-linaria.css';
import { css } from '@linaria/core';
import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';
import { i18n } from './i18n';
export const notifyError = (message?: string, options?: Partial<Parameters<typeof Toastify>[0]>) => {
  const toast = Toastify({
    text: message || i18n.errorOccurred,
    duration: 0,
    className: "c1xyzdi9",
    onClick: () => toast.hideToast(),
    ...options
  });
  toast.showToast();
};
export const notifyWarning = (message: string, options?: Partial<Parameters<typeof Toastify>[0]>) => {
  const toast = Toastify({
    text: message,
    duration: 0,
    className: "c1lal3kf",
    onClick: () => toast.hideToast(),
    ...options
  });
  toast.showToast();
};